import React from "react";
import { Box, Grid, Flex, Text, Icon } from "@chakra-ui/react";
import { FiAlertCircle, FiCheckCircle } from "react-icons/fi";
import { LuTrendingUp, LuZap } from "react-icons/lu";
export const DeliveryDistributionCards = ({ distributionData }) => {
  const cards = [
    {
      label: "Super Fast",
      time: "< 30 sec",
      icon: FiCheckCircle,
      bg: "#f0fdf4",
      borderColor: "#b9f8cf",
      labelColor: "#016630",
      iconColor: "#00a63e",
      valueColor: "#008236",
      percentColor: "#008236",
      countColor: "green.500",
      percentage: distributionData.less_30_sec_percent,
      count: distributionData.less_30_sec
    },
    {
      label: "Fast",
      time: "< 1 min",
      icon: LuZap,
      bg: "var(--brand-tint)",
      borderColor: "var(--brand-tint-strong)",
      labelColor: "#193cb8",
      iconColor: "#155dfc",
      valueColor: "var(--brand-primary-hover)",
      percentColor: "#155dfc",
      countColor: "#2b7fff",
      percentage: distributionData.less_1_min_percent,
      count: distributionData.less_1_min
    },
    {
      label: "Delayed",
      time: "< 5 min",
      icon: FiAlertCircle,
      bg: "#fff7ed",
      borderColor: "#ffd7a8",
      labelColor: "#9f2d00",
      iconColor: "#f54a00",
      valueColor: "#ca3500",
      percentColor: "#f54a00",
      countColor: "#ff6900",
      percentage: distributionData.less_5_min_percent,
      count: distributionData.less_5_min
    },
    {
      label: "Outliers",
      time: "> 5 min",
      icon: LuTrendingUp,
      bg: "#fef2f2",
      borderColor: "#ffc9c9",
      labelColor: "#9f0712",
      iconColor: "#e7000b",
      valueColor: "#c10007",
      percentColor: "#e7000b",
      countColor: "#fb2c36",
      percentage: distributionData.more_5_min_percent,
      count: distributionData.more_5_min
    }
  ];

  return (
    <Grid
      templateColumns={{ base: "1fr", md: "repeat(4, 1fr)" }}
      gap={4}
    >
      {cards.map((card, index) => (
        <Box
          key={index}
          p={4}
          bg={card.bg}
          rounded="lg"
          border="1px"
          borderColor={card.borderColor}
        >
          <Flex justify="space-between" align="center" mb={2}>
            <Text fontSize="sm" fontWeight="500" color={card.labelColor}>
              {card.label}
            </Text>
            <Icon as={card.icon} boxSize={4} color={card.iconColor} />
          </Flex>
          
          <Text fontSize="2xl" fontWeight="semibold" color={card.valueColor}>
            {card.time}
          </Text>
          
          <Text fontSize="xs" color={card.percentColor} mt={1}>
            {card.percentage.toFixed(1)}% of messages
          </Text>
          
          <Text fontSize="xs" color={card.countColor} mt={0.5}>
            {card.count.toLocaleString()} messages
          </Text>
        </Box>
      ))}
    </Grid>
  );
};